<template>
<v-card :flat='flat' >
  <v-card-title
    v-if='appointmentIds'
    class='subheading' >
    {{ $tc('title', appointmentIds.length, { count: appointmentIds.length } ) }}
    <v-spacer></v-spacer>
    <v-btn v-if='!showDetails' flat small @click='expand' >{{ $t('buttons.more') }}</v-btn>
    <v-btn v-else flat small @click='showDetails=false' >{{ $t('buttons.less') }}</v-btn>
  </v-card-title>
  <v-card-text v-if='showDetails' >
    <v-progress-linear
      v-if='request.loading'
      height="3"
      class='my-0'
      indeterminate >
    </v-progress-linear>
    <v-list three-line v-if='appointments' class='elevation-3'>
      <v-subheader>{{ $t('sleecteditems') }}</v-subheader>
      <appointment-list-item
        v-for='appointment in appointments'
        :key='appointment.id'
        :with-action='false'
        :with-tags='true'
        :appointment='appointment' >
        <!-- <v-list-tile-action slot='actions' >
          <v-icon>check_box</v-icon>
        </v-list-tile-action> -->
      </appointment-list-item>
    </v-list>
  </v-card-text>
</v-card>
</template>

<script>
import AppointmentListItem from '@/components/appointment/AppointmentListItem'

export default {
  name: 'SelectedAppointmentsPreview',
  components: {AppointmentListItem},
  props: {
    appointmentIds: { type: Array, default: () => { return [] } },
    flat: { type: Boolean, default: false }
  },
  data () {
    return {
      showDetails: false,
      reqId: 'get-specific-appointments-request'
    }
  },
  computed: {
    request () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    appointments () {
      return this.getObjectPath(this.request, 'result.data', [])
    }
  },
  methods: {
    expand () {
      this.showDetails = true
      this.getAppointments()
    },
    getAppointments () {
      let params = {
        ids: this.appointmentIds.join(',')
      }
      this.$appointmentguru
        .resource('appointment')
        .id(this.reqId)
        .list(params)
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'With selected appointment | With {count} selected appointments',
        sleecteditems: 'Selected appointments',
        buttons: {
          more: 'Show details',
          less: 'Hide details'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// SelectedAppointmentsPreview.vue?4608430a